// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"280":"css/dashboard","364":"css/app"}[chunkId] + ".css";
};